export default {
      id: "Icon_Visible-usage",
      viewBox: "0 0 19 10",
      url: __webpack_public_path__ + "img/icons.svg#Icon_Visible",
      toString: function () {
        return this.url;
      }
    }